
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf-to-flashcards",
      function () {
        return require("private-next-pages/pdf-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf-to-flashcards"])
      });
    }
  